import { defineRouting } from 'next-intl/routing'

/**
 * i18n 相关配置
 */
const i18nRouting = defineRouting({
  localeDetection: false,
  localeCookie: true,
  alternateLinks: false,
  // A list of all locales that are supported
  locales: [
    // 'zh-Hans',
    'es-MX',
  ],
  // Used when no locale matches
  defaultLocale: 'es-MX',
  // Configures whether and which prefix
  // localePrefix: {
  //   mode: 'always',
  //   prefixes: {
  //     'zh-Hans': '/zh',
  //     'en-US': '/us',
  //   },
  // },
  localePrefix: 'never',
  // change the locale handling per domain
  domains: [
    {
      // TODO: 替换为真实域名
      domain: 'store-mx.segway.com',
      defaultLocale: 'es-MX',
      // Optionally restrict the locales available on this domain
      // If there are no `locales` specified on a domain,
      // all available locales will be supported here
      locales: ['es-MX'],
    },
    // {
    //   domain: "us.example.com",
    //   defaultLocale: "en",
    //   locales: ["en"],
    // },
  ],
  // The `pathnames` object holds pairs of internal and
  // external paths. Based on the locale, the external
  // paths are rewritten to the shared, internal ones.
  pathnames: {},
  // The `matcher` is relative to the `basePath`
  // matcher: [
  // This entry handles the root of the base
  // path and should always be included
  // '/',
  // ... other matcher config
  // ],
})

export default i18nRouting
